<template>
  <div>
    <h1 class="applicationNav">
      <span>二级注册建筑师证书信息</span>
    </h1>
    <section class="query-container">
      <el-form action="" :model="formData" ref="formData">
        <el-form-item label="身份证号或姓名" prop="name">
          <el-input
            placeholder="请输入身份证号或姓名（必填）"
            prefix-icon="el-icon-document"
            v-model="formData.name"
          >
          </el-input>
        </el-form-item>
        <div class="verification-code clearfix">
          <el-form-item label="验证码" prop="code" :rules="formRules.code">
            <el-input
              placeholder="请输入验证码"
              prefix-icon="el-icon-edit"
              v-model="formData.code"
            >
            </el-input>
          </el-form-item>
          <div class="code" @click="updateCode">
            <canvas id="canvas" width="100" height="45"></canvas>
          </div>
        </div>
        <div class="form-btn clearfix">
          <input
            type="button"
            class="submit"
            value="立即查询"
            @click="validateForm('formData')"
          />
          <input
            type="reset"
            @click="resetForm('formData')"
            value="重置信息"
            class="reset"
          />
        </div>
      </el-form>
    </section>
    <section class="result-container" v-if="isOpenResultContaniner">
      <h1 class="applicationNav">
        <span>查询结果</span>
      </h1>
      <div class="results" v-if="isOpenResult">
        <table v-for="(item, index) in results" :key="index" class="result-box">
          <tr>
            <td>姓名</td>
            <td>
              {{ desensitizedCommon(item.xm, 0, 1) || "暂无数据" }}
            </td>
            <td>证书编号</td>
            <td>{{ item.zcbh || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>身份证号码</td>
            <td>{{ item.zjh || "暂无数据" }}</td>
            <td>有效期</td>
            <td>{{ item.zcyxq || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>发证机关</td>
            <td colspan="3">{{ item.fzdw || "暂无数据" }}</td>
          </tr>
        </table>
        <div class="block">
          <el-pagination
            background
            @current-change="currentChange"
            :current-page="pageNum"
            :page-size="5"
            prev-text="上一页"
            next-text="下一页"
            :hide-on-single-page="true"
            layout="total, prev, pager, next"
            :total="count"
          >
          </el-pagination>
        </div>
        <!-- <div class="tips">注：查询结果仅为甘肃省常住人口</div> -->
      </div>
      <div class="no-results" v-else>
        <img src="../assets/img/zwjl.png" alt="" />
        <p>{{ info }}</p>
      </div>
    </section>
  </div>
</template>
<script>
import { createCode, validateCode } from "@/utils/checkCode";
import IndexApi from "@/api/index";
import sm2 from "@/utils/sm2";
import { desensitizedCommon } from "@/utils/desensitized";
export default {
  name: "IndexView",
  created() {},
  mounted() {
    createCode();
  },
  data() {
    const checkCode = (rule, value, callback) => {
      if (!validateCode(value.toLowerCase())) {
        this.formData.code = "";
        return callback(new Error("验证码错误"));
      }
      callback();
    };

    return {
      info: "",
      isOpenResultContaniner: false,
      isOpenResult: false,
      formData: {
        name: "",
        code: "",
      },
      form: {},
      publicKey:
        "04f40d97e9c997ee436047255acfbd68c993bcac96460da53f61e60e74808f521098e27917ec331805f9dcba11404a0f811786d5fa940f5eaa86c32c475ef01700",
      privateKey:
        "3fce91c669c4769381384edcd8d63515362f222e9025f7f8b52f4f7ef2c38c69",
      pageNum: 1,
      count: 0,
      bnum: 0,
      results: [],
      formRules: {
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "验证码不能为空", trigger: "focus" },
          { min: 4, max: 4, message: "验证码长度为4个字符", trigger: "focus" },
          { validator: checkCode, trigger: "focus" },
        ],
      },
    };
  },
  methods: {
    desensitizedCommon,
    updateCode() {
      createCode();
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        createCode();
        if (valid) {
          this.form.name = this.formData.name;
          this.pageNum = 1;
          this.getData();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.isOpenResult = false;
      this.isOpenResultContaniner = false;
      createCode();
    },
    async getData() {
      window.openModel();
      let params = {
        zjh: sm2.encrypt(this.form.name, this.publicKey),
      };
      let res;
      try {
        res = await IndexApi.queryList(params);
        new URLSearchParams();
        new FormData();
      } catch (e) {
        window.closeModel();
        window.openAlert("网络错误，请重试");
        return;
      }
      window.closeModel();
      this.isOpenResultContaniner = true;
      console.log(
        JSON.parse(sm2.decrypt(res.data.data.slice(2), this.privateKey))
      );
      if (
        res.code == "200" &&
        res.success == true &&
        JSON.parse(sm2.decrypt(res.data.data.slice(2), this.privateKey))
          .length > 0
      ) {
        this.isOpenResult = true;
        this.results = JSON.parse(
          sm2.decrypt(res.data.data.slice(2), this.privateKey)
        );
        this.count = this.results.length;
      } else {
        this.isOpenResult = false;
        this.info = "查询无结果";
      }
    },
    currentChange(val) {
      this.pageNum = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
</style>
